import {Button, Dropdown, DropdownProps, Menu, MenuProps} from 'antd';
import React, {useCallback, useState} from "react";
import {DownloadOutlined, FileImageOutlined} from "@ant-design/icons";
import NegotiationTablesDownloadModal from "../modals/NegotiationTablesDownloadModal";
import ReportDownloadModal from "../modals/ReportDownloadModal";
import {useSelector} from "react-redux";
import {selectUser} from "../../redux/features/userSlice";
import {canDownloadBrokerDataXlsx, canDownloadFeeBank, canDownloadUW} from "../../utils/permission";
import {useLazyGetSaleExtractionQuery} from "../../redux/api/extractionToXlsx";
import UnderwriterDownloadModal from "../modals/UnderwriterDownloadModal";

const NEGOTIATIONS = 'NEGOTIATIONS'
const REPORT = 'REPORT'
const UNDERWRITER = 'UNDERWRITER'
const SALEEXTRACTION = 'SALEEXTRACTION'

type PossibleModalValue = typeof NEGOTIATIONS | typeof REPORT | typeof UNDERWRITER | null

export default function NegotiationTablesDownloadButton() {
    const user = useSelector(selectUser)

    const [download, {isLoading}] = useLazyGetSaleExtractionQuery()

    const [showModal, setShowModal] = useState<PossibleModalValue>(null)
    const canDownloadBrokerData = canDownloadBrokerDataXlsx(user?.usertypes.map(el => el.code) || [])
    const canDownloadFeeBankPerc = canDownloadFeeBank(user?.usertypes.map(el => el.code) || [])
    const canDownloadUWReport = canDownloadUW(user?.usertypes.map(el => el.code) || [])

    const downloadSaleExtraction = useCallback(() => {
        download()
    }, [download])

    const handleMenuClick: MenuProps['onClick'] = e => {
        switch (e.key) {
            case NEGOTIATIONS:
                setShowModal(NEGOTIATIONS)
                break;
            case REPORT:
                setShowModal(REPORT)
                break;
            case UNDERWRITER:
                setShowModal(UNDERWRITER)
                break;
            case SALEEXTRACTION:
                downloadSaleExtraction()
                break;
        }
    }

    const menuItems = () => {
        let items = [
            {
                label: 'Trattative',
                key: NEGOTIATIONS,
                icon: <FileImageOutlined/>,
            },
            {
                label: 'Reportistica',
                key: REPORT,
                icon: <FileImageOutlined/>,
            },
        ]
        if (canDownloadFeeBankPerc)
            items.push({
                label: 'Fee Banca',
                key: SALEEXTRACTION,
                icon: <FileImageOutlined/>,
            })
        if (canDownloadUWReport)
            items.push({
                 label: "Estrazione UW",
                key: UNDERWRITER,
                icon: <FileImageOutlined/>
            })
        return items
    }

    const menuProps: DropdownProps["menu"] = {
        onClick: handleMenuClick,
        items: menuItems()
    }

    return (
        <>
            {canDownloadBrokerData && <>
                <Dropdown menu={menuProps} trigger={['click']}>
                    <Button
                        size='large'
                        icon={<DownloadOutlined/>}
                        style={{
                            borderColor: 'transparent',
                            backgroundColor: 'transparent',
                            boxShadow: "none"
                        }}
                    />
                </Dropdown>
                <ReportDownloadModal isModalVisible={showModal === REPORT} closeModal={() => setShowModal(null)}/>
                <NegotiationTablesDownloadModal isModalVisible={showModal === NEGOTIATIONS}
                                                closeModal={() => setShowModal(null)}/>
                <UnderwriterDownloadModal isModalVisible={showModal === UNDERWRITER} closeModal={() => setShowModal(null)}/>
            </>}

            {!canDownloadBrokerData && <>
                <Button
                    size='large'
                    icon={<DownloadOutlined/>}
                    style={{
                        borderColor: 'transparent',
                        backgroundColor: 'transparent',
                        boxShadow: "none"
                    }}
                    onClick={() => setShowModal(NEGOTIATIONS)}
                />
                <NegotiationTablesDownloadModal isModalVisible={showModal === NEGOTIATIONS}
                                                closeModal={() => setShowModal(null)}/>
            </>}
        </>
    );
}